import { JobType } from '../../../../contentful/types/IJob';

export function isJobType(value: unknown): value is JobType {
	return value != null && Object.values(JobType).includes(value as JobType);
}
